import {useMemo} from 'react'

import type {Build} from '../../../../../services/rest'
import {restApi} from '../../../../../services/rest'
import {emptyArray} from '../../../../../utils/empty'
import {PipelineChart} from '../../components/common/PipelineChart/PipelineChart'
import {createGraph} from '../../utils/graph'
import {usePipelineRunArg} from '../PipelineRunPage.hooks'

import PipelineRunJob from './PipelineRunJob/PipelineRunJob'

const NODE_HEIGHT = 116
const NODE_WIDTH = 204

export default function PipelineRunChart() {
  const arg = usePipelineRunArg()
  const {dependencies} = restApi.endpoints.getBuildNormalized.useQuery(arg, {
    selectFromResult: ({data}) => {
      const run = data?.entities?.builds?.[data?.result!]
      return {
        dependencies: run?.['snapshot-dependencies']?.build ?? emptyArray,
      }
    },
  })
  const graph = useMemo(
    () =>
      createGraph<Build>({
        data: dependencies,
        getId: build => String(build.id),
        getDependencies: build =>
          build['snapshot-dependencies']?.build?.map(dep => String(dep.id)) ?? emptyArray,
      }),
    [dependencies],
  )
  return (
    <PipelineChart
      graph={graph}
      nodeWidth={NODE_WIDTH}
      nodeHeight={NODE_HEIGHT}
      pointOffsetY={15}
      renderJob={({data, x, y}) => (
        <PipelineRunJob
          x={x! - NODE_HEIGHT / 2}
          y={y! - NODE_WIDTH / 2}
          jobId={Number(data.id)}
          key={data.id}
        />
      )}
    />
  )
}
